export class PolicyHolderInfo {
  // public 変数 ------------------------------------------------------------------------
  public surName:		string = null;    // 氏名（姓）
  public surNameKana: 	string = null;    // 氏名カナ（姓）
  public firstName:		string = null;    // 氏名（名）
  public firstNameKana:	string = null;    // 氏名カナ（名）
  public dateOfBirth:	string = null;    // 生年月日
  public gender:		string = null;    // 性別
  public postCode:		string = null;    // 郵便番号
  public prefecture:	string = null;    // 都道府県
  public address1:		string = null;    // 住所１
  public address2:		string = null;    // 住所２
  public phoneNumber:	string = null;    // 電話番号
  public mailAddress:	string = null;    // メールアドレス
  // -------------------------------------------------------------------------------------
}
